module.exports = __webpack_public_path__ + "15D66911-5971-413F-A6A4-0A46FDC15AC6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/15D66911-5971-413F-A6A4-0A46FDC15AC6.jpeg
// module id = 840
// module chunks = 0